// Echelon Policy Page Fix
// Handles policy pages by hiding the React overlay and showing styled Shopify policy HTML
(function() {
  var p = window.location.pathname;
  
  // Redirect TOS to T&C page
  if (p === '/policies/terms-of-service' || p === '/policies/terms_of_service') {
    window.location.replace('/pages/terms-and-conditions');
    return;
  }
  
  // Redirect /pages/privacy-policy to the correct policy URL
  if (p === '/pages/privacy-policy') {
    window.location.replace('/policies/privacy-policy');
    return;
  }
  
  // For all other /policies/* pages: hide React overlay, apply dark styling, show Shopify policy HTML
  if (p.indexOf('/policies/') === 0) {
    // Inject dark-theme styles for the policy page
    function injectStyles() {
      if (document.getElementById('ec-policy-styles')) return;
      var style = document.createElement('style');
      style.id = 'ec-policy-styles';
      style.textContent = [
        'body{background:#08142E!important;color:#d1d5db!important;font-family:\'Inter\',sans-serif!important;margin:0;padding:0}',
        '.shopify-policy__container{max-width:56rem;margin:0 auto;padding:4rem 1.5rem 6rem;background:transparent!important;color:#d1d5db!important}',
        '.shopify-policy__container h1{font-family:\'Barlow\',sans-serif;font-size:2.25rem;font-weight:700;color:#fff!important;margin:0 0 2rem;letter-spacing:-.01em}',
        '.shopify-policy__container h2,.shopify-policy__container h3{font-family:\'Barlow\',sans-serif;color:#fff!important;margin-top:2rem;margin-bottom:.75rem}',
        '.shopify-policy__container p{margin:.75rem 0;line-height:1.75;font-size:.9375rem;color:#d1d5db!important}',
        '.shopify-policy__container a{color:#C8A96E!important}',
        '.shopify-policy__container ul,.shopify-policy__container ol{margin:.75rem 0 .75rem 1.5rem;color:#d1d5db!important}',
        '.shopify-policy__container li{margin:.4rem 0;line-height:1.7;font-size:.9375rem;color:#d1d5db!important}',
        '.shopify-policy__container strong{color:#fff!important}',
        '#ec-policy-header{background:#0a1628;border-bottom:1px solid rgba(255,255,255,0.08);padding:1.25rem 1.5rem;display:flex;align-items:center;justify-content:space-between;position:fixed;top:0;left:0;right:0;z-index:9999}',
        '#ec-policy-header a.logo{font-family:\'Barlow\',sans-serif;font-weight:800;font-size:1.25rem;color:#fff;text-decoration:none;letter-spacing:.05em}',
        '#ec-policy-header a.back{font-size:.875rem;color:#9ca3af;text-decoration:none}',
        '#ec-policy-header a.back:hover{color:#fff}',
        '.shopify-policy__container{padding-top:6rem!important}',
        '#ec-policy-footer{border-top:1px solid rgba(255,255,255,0.08);padding:2rem 1.5rem;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:1rem;max-width:56rem;margin:0 auto}',
        '#ec-policy-footer p{font-size:.875rem;color:#4b5563;margin:0}',
        '#ec-policy-footer a{font-size:.875rem;color:#6b7280;text-decoration:none;margin-left:1.5rem}',
        '#ec-policy-footer a:hover{color:#C8A96E}'
      ].join('\n');
      document.head.appendChild(style);
    }
    
    function showPolicyContent() {
      // Hide React root
      var root = document.getElementById('root');
      if (root) {
        root.style.display = 'none';
        root.style.visibility = 'hidden';
        root.style.opacity = '0';
        root.style.pointerEvents = 'none';
        root.style.position = 'absolute';
        root.style.top = '-9999px';
      }
      
      // Show Shopify policy container
      var policyContainers = document.querySelectorAll('.shopify-policy__container');
      policyContainers.forEach(function(el) {
        el.style.display = 'block';
        el.style.visibility = 'visible';
      });
      
      // If the theme.liquid policy template is NOT already rendering (no ec-policy-header),
      // inject our own header, dark styles, and footer
      if (!document.getElementById('ec-policy-header') && policyContainers.length > 0) {
        injectStyles();
        
        // Inject header
        var header = document.createElement('div');
        header.id = 'ec-policy-header';
        header.innerHTML = '<a href="/" class="logo">ECHELON COMMERCIAL</a><a href="/" class="back">\u2190 Back to Home</a>';
        document.body.insertBefore(header, document.body.firstChild);
        
        // Inject footer after the policy container
        var footer = document.createElement('div');
        footer.id = 'ec-policy-footer';
        var year = new Date().getFullYear();
        footer.innerHTML = '<p>&copy; ' + year + ' Echelon Fitness Multimedia, LLC. All rights reserved.</p>' +
          '<div><a href="/pages/terms-and-conditions">Terms &amp; Conditions</a><a href="/">Home</a></div>';
        var container = policyContainers[0];
        container.parentNode.insertBefore(footer, container.nextSibling);
      }
    }
    
    // Run on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showPolicyContent);
    } else {
      showPolicyContent();
    }
    
    // Also run after delays to override React rendering
    setTimeout(showPolicyContent, 100);
    setTimeout(showPolicyContent, 500);
    setTimeout(showPolicyContent, 1000);
  }
})();
